export default "__VITE_ASSET__B2B0$B3J__"